// Consumer email domains we refuse for organizer signup.
// Keep this conservative. False negatives (consumer domain not on the list)
// are recoverable; false positives (work domain blocked) bounce a real user.

const CONSUMER_DOMAINS = new Set<string>([
  'gmail.com', 'googlemail.com',
  'yahoo.com', 'ymail.com', 'rocketmail.com',
  'hotmail.com', 'live.com', 'msn.com', 'outlook.com',
  'icloud.com', 'me.com', 'mac.com',
  'aol.com', 'aim.com',
  'proton.me', 'protonmail.com', 'pm.me',
  'gmx.com', 'gmx.us',
  'mail.com', 'mailinator.com',
  'duck.com', 'duckduckgo.com',
  'fastmail.com',
  'zoho.com',
  'qq.com', '163.com', '126.com',
]);

export function getEmailDomain(email: string): string {
  return email.trim().toLowerCase().split('@')[1] ?? '';
}

export function isValidEmailShape(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export type EmailCheck =
  | { ok: true; domain: string }
  | { ok: false; reason: 'shape' | 'consumer'; domain: string };

export function checkWorkEmail(email: string): EmailCheck {
  const domain = getEmailDomain(email);
  if (!isValidEmailShape(email)) return { ok: false, reason: 'shape', domain };
  if (CONSUMER_DOMAINS.has(domain)) return { ok: false, reason: 'consumer', domain };
  return { ok: true, domain };
}
